'use client'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/navigation'
import React, { useEffect, useMemo, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { fr } from 'date-fns/locale/fr';
import ReactDatePicker from 'react-datepicker';
import { DateTime } from 'luxon';

type Props = {
    searchParams: URLSearchParams
}

const FilterVenteDate = ({ searchParams }: Props) => {

    const pathName = usePathname()
    const params = useMemo(() => new URLSearchParams(searchParams), [searchParams])
    const router = useRouter()

    const [datesSelected, setDatesSelected] = useState<{
        startDate: string | null,
        endDate: string | null
    }>({
        startDate: null,
        endDate: null
    
    })

    const handleChange = async ([start, end]: [Date | null, Date | null]) => {

        // suppression des paramètres de date de vente
        params.delete('startDateVente')
        params.delete('endDateVente')
        params.set('page', '1')

        // ajout du nouveau paramètre de date de vente
        if (start) {
            params.append('startDateVente', DateTime.fromJSDate(start).toISODate()!)
        }

        if (end) {
            params.append('endDateVente', DateTime.fromJSDate(end).toISODate()!)
        }

        setDatesSelected({
            ...datesSelected,
            startDate: start ? DateTime.fromJSDate(start).toISODate()! : null,
            endDate: end ? DateTime.fromJSDate(end).toISODate()! : null
        })

        router.push(pathName + '?' + params.toString())

    };

    useEffect(() => {

        setDatesSelected({
            startDate: params.has('startDateVente') ? params.get('startDateVente') : null,
            endDate: params.has('endDateVente') ? params.get('endDateVente') : null
        })
    }, [params])

    return (
        <div className='w-full lg:w-1/3'>
            <ReactDatePicker
                id='select-date-vente'
                name='dateVente'
                placeholderText="Dates de ventes (sélectionner une période)"
                className='w-full px-2 py-[8px] text-sm grow rounded-md border border-zinc-300 bg-white text-zinc-700 focus:border-zinc-500 focus:ring-zinc-500 focus:ring-1 duration-700 hover:border-zinc-500 hover:ring-zinc-500 hover:ring-1'
                disabledKeyboardNavigation
                dateFormat="dd/MM/yyyy"
                onKeyDown={(e) => { e.preventDefault() }}
                onChange={(dates) => handleChange(dates)}
                locale={fr}
                selected={datesSelected.startDate ? DateTime.fromISO(datesSelected.startDate).toJSDate() : null}
                startDate={datesSelected.startDate ? DateTime.fromISO(datesSelected.startDate).toJSDate() : undefined}
                endDate={datesSelected.endDate ? DateTime.fromISO(datesSelected.endDate).toJSDate() : undefined}
                selectsRange
                autoComplete='off'
                isClearable
                popperClassName='!z-[9999]'
            />
            <label className="sr-only" htmlFor="select-date-vente">Filtre département</label>
        </div>
    )
}


export default FilterVenteDate